{
  "id": "paywall-picker-2026-10",
  "status": "on",
  "start": "2026-10-16T12:00:00Z",
  "salt": "paywall-picker-2026-10",
  "share": 50,
  "minAppVersion": { "ios": "4.3.2", "android": "4.3.7" },
  "platforms": { "web": true, "ios": true, "android": true },
  "force": {}
}
